/*
* pop-regex-validate directive to validate field using regular expression value
* params: pop-regex-validate-flags
*/
App.directive('popRegexValidate', function() {
    return {
	    /* restrict to an attribute type. */
	    restrict: 'A',

	    /* element must have ng-model attribute. */
	    require: 'ngModel',

	    /* scope = the parent scope
	    *         elem = the element the directive is on
	    *                 attr = a dictionary of attributes on the element
	    *                         ctrl = the controller for ngModel.
	    *                                 */
	    link: function(scope, elem, attr, ctrl) {

	        /* get the regex flags from the regex-validate-flags="" attribute (optional) */
	        var flags = attr.popRegexValidateFlags || '';

	        /* create the regex obj. */

	        scope.$watch(attr.ngModel, function(value){

	            var regex = new RegExp(attr.popRegexValidate, flags);

	            if(regex.test(value))
	            {
	                ctrl.$setValidity('regexValidate', true);
	            } else {
	                ctrl.$setValidity('regexValidate', false);
	            }
	        });

	    }
	};
});

/*
* ng-enter directive to execute expression on enter
*/
App.directive('ngEnter', function () {
  return function (scope, element, attrs) {
    element.bind("keyup", function (event) {
      if(event.which === 13) {
        scope.$Apply(function (){
          scope.$eval(attrs.ngEnter);
        });
      
        event.preventDefault();
      }
    });
  };
});


/*
 * pop-regex directive to execute expression if regex is true
 */
App.directive('popRegex', function(){
	return function (scope,element,attrs) {
		var regex = new RegExp(attrs.popRegex);
		if(regex.test(element.html()))
		{
			scope.$Apply( function(){
				scope.$eval(attrs.popRegexExec);
			});
		}
	}
});

/*
 * pop-hilite-tld directive to wrap tld in specified tag
 */
App.directive('popHiliteTldWith', function() {
	return {
		restrict: 'A',
		scope: {
			ngModel: '='
		},
		link : function (scope, element, attrs) {

			var idx = element.html().indexOf('.'),
				html = element.html();

			if(idx != -1)
			{
				element.html(html.replace('.', '<' + attrs.popHiliteTldWith + '>.') + '</' + attrs.popHiliteTldWith + '>');
			}

		}
	}
});

/*
 * pop-resize directive to resize parent container
 */
App.directive('popResize', function() {
	return {
		restrict: 'A',
		link : function (scope, el, attrs) {
			var $el = $(el),
				$parent = $el.parent(),
				resizeBy = $el.find('.signup-view').css('max-height');
			
			//this is a force resize for .us
			if(attrs.popResizeForce === 'true' && scope.selectedDomain){
				if(scope.selectedDomain.TLD == 'us')
				{
					$parent.height(parseInt(resizeBy.split('px')[0]) + 200);
				} else {
					$parent.height(resizeBy);
				}
				return;
			}

			$parent.height(resizeBy);
		}
	}
});

/*
 * pop-popover directive to bind popover elements on dom creation
 */
App.directive('popPopover', function() {
	return {
		restrict: 'A',
		link: function(scope,el,attrs) {
			var placement = 'bottom';
			if(el.data('placement'))
			{
				placement = el.data('placement');
			}
			$(el).popover({trigger : 'click hover', placement: placement });
		}
	}
});
